// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"d5ad892e","310":"97bdee68","787":"e43e55fe"}[chunkId] + ".chunk.js";
};